import { Trans } from "react-i18next";
import { Card, CardHeader, CardBody, Text, Button } from "grommet";
import { FormClose } from "grommet-icons";
import { LinkRenderer } from "../../layout/LinkRenderer";

export const EliminatedCard = ({ droppedOutSector, show, onClose }) => {

    if (show && droppedOutSector) {
        return (
            <Card height={{ min: 'small' }} width={{ min: 'medium' }} background="#222222" elevation="large" round="small" style={{ pointerEvents: 'auto' }}>
                <CardHeader justify="end" pad={{ top: 'small', right: 'small', bottom: 'none' }}>
                    <Button icon={<FormClose />} onClick={onClose} />
                </CardHeader>
                <CardBody pad={{ bottom: 'medium', horizontal: 'medium' }} align="center" justify="center">
                    <Text size="medium" align="center">
                        <Trans i18nKey="wheel:eliminationDialogText" />
                    </Text>
                    <Text size="medium" align="center" weight="bold" color="status-critical">
                        <LinkRenderer text={droppedOutSector.lotName} />
                    </Text>
                </CardBody>
            </Card>
        )
    }
    return null;
}